export default __webpack_public_path__ + "static/heroSectionBg-82fafddffb3bb0da52790bd13c70d59e.png";